export default {
  loading: false,
  error: false,
  items: [],
  pagination: {
    limit: 10,
    page: 0,
    total: 0
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profilePosts/profilePostsState.js